// extracted by mini-css-extract-plugin
module.exports = {"tab":"accordion-tab_tab__ytE1a","tabContent":"accordion-tab_tabContent__JuCIT","tabLabel":"accordion-tab_tabLabel__Zn9Ej","fade-in":"accordion-tab_fade-in__X5nv5"};